module.exports = __webpack_public_path__ + "img/SHOPPING_BAG.7ab07f8a.svg";